"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigationItems = void 0;
/**
 * The list of registered navigation items.
 */
exports.navigationItems = {
    home: {
        url: '/home',
        icon: 'house-blank',
        translationKey: 'dashboard',
    },
    learn: {
        url: '/learn/courses',
        icon: 'books',
        translationKey: 'courses',
    },
    news: {
        url: '/news',
        icon: 'bullhorn',
        translationKey: 'news',
    },
    calendar: {
        url: '/calendar',
        icon: 'calendar',
        translationKey: 'calendar',
    },
    schedule: {
        url: '/schedule',
        icon: 'calendar',
        translationKey: 'schedule',
    },
    community: {
        url: '/community',
        icon: 'users',
        translationKey: 'community',
    },
    studyManagement: {
        url: '/study-management',
        icon: 'notebook',
        translationKey: 'studyManagement',
    },
    // Different translation key, but same URL as studyManagement
    trainingOrganization: {
        url: '/study-management',
        icon: 'notebook',
        translationKey: 'trainingOrganization',
    },
    infoCenter: {
        url: '/info-center',
        icon: 'circle-info',
        translationKey: 'infocenter',
    },
    faq: {
        url: '/faq',
        icon: 'circle-question',
        translationKey: 'help',
    },
    dataPrivacy: {
        url: '/data-privacy',
        translationKey: 'data-privacy',
    },
    legal: {
        url: '/legal',
        translationKey: 'legal',
    },
    lectures: {
        url: '/lectures',
        icon: 'calendar',
        translationKey: 'lectures',
    },
    examination: {
        url: '/examination',
        icon: 'graduation-cap',
        translationKey: 'examination',
    },
};
